import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import { localize } from 'helpers/translator'
import interactiveVideoActions from 'redux/actions/interactiveVideoActions'

import Confirm from 'views/confirm/confirm'

class IVideoCreationActivityCancelConfirm extends PureComponent {
	render() {
		return (
			<Confirm
				btOne={localize('global_no')}
				btTwo={localize('global_yes')}
				alertMessage={localize('oeq_cancelConfirm')}
				actionButtonType={0}
				actionOne={this.props.actions.cancelRejected}
				actionTwo={this.props.actions.cancelConfirmed}
				closeAction={this.props.actions.cancelRejected}
			/>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		cancelConfirmed:
			interactiveVideoActions.cancelActivityConfirmed,
		cancelRejected:
			interactiveVideoActions.cancelActivityRejected,
	}, dispatch)
}

IVideoCreationActivityCancelConfirm.propTypes = {
	actions: PropTypes.shape({
		cancelConfirmed: PropTypes.func.isRequired,
		cancelRejected: PropTypes.func.isRequired,
	}),
}

export default connect(null, mapDispatchToProps)(
	IVideoCreationActivityCancelConfirm
)

export { IVideoCreationActivityCancelConfirm }
